<div class="result-card">
  <div class="header">
    <div class="name">{{memberData?.fullName?.lastName}}, {{memberData?.fullName?.firstName}}</div>
    <div class="group-number">Group Number: {{memberData?.groupNumber}}</div>
  </div>
  <div class="body">
    <div class="row">
      <div class="key-val-left-wrapper">
        <div class="key-val">
          <div class="key">Date of Birth:</div>
          <div class="val">{{memberData?.dateOfBirth}}</div>
        </div>
        <div class="key-val">
          <div class="key">Phone Number:</div>
          <div class="val">{{memberData?.phone}}</div>
        </div>
      </div>
      <div class="key-val-right">
        <div class="key">Address:</div>
        <div class="val">{{memberData?.homeAddress?.address}} {{memberData?.homeAddress?.address2}} {{memberData?.homeAddress?.city}}, {{memberData?.homeAddress?.state}} {{memberData?.homeAddress?.zipCode}}</div>
      </div>
    </div>
    <hr class="line">
    <div class="row">
      <div class="key-val-left">
        <div class="key">Plan Name:</div>
        <div class="val">{{memberData?.coverageData?.planName}}</div>
      </div>
      <div class="key-val-right">
        <div class="key">Effective Date:</div>
        <div class="val">{{memberData?.effectiveDate}}</div>
      </div>
    </div>
    <div class="row">
      <div class="bl">
        <div class="cov">Coverage Includes</div>
        <div class="images">
          <div [ngClass]="{'hide' : showMedical.toString() === 'false'?true:false}">
            <img class="a" alt="Medical Coverage" src="{{angularHostUrl}}assets/images/indicator-icons/shopcard_medical.svg"><span class="a2">Medical</span>
          </div>
          <!-- <img class="a1" alt="Prescription Coverage" src="{{angularHostUrl}}assets/images/indicator-icons/shopcard_prescription.svg"><span class="a2">Prescription</span> -->
          <div [ngClass]="{'hide' : showDental.toString() === 'false'?true:false}">
            <img class="a1" alt="Dental Coverage" src="{{angularHostUrl}}assets/images/indicator-icons/shopcard_dental.svg"><span class="a2">Dental</span>
          </div>
          <div [ngClass]="{'hide' : showVision.toString() === 'false'?true:false}">
            <img class="a1" alt="Vision Coverage" src="{{angularHostUrl}}assets/images/indicator-icons/shopcard_vision.svg"><span class="a2">Vision</span>
          </div>
          <!-- <img class="a1" alt="Hearing Coverage" src="{{angularHostUrl}}assets/images/indicator-icons/shopcard_hearing.svg"><span class="a2">Hearing</span> -->
        </div>
      </div>
      @if (showContinueButton()) {
        <div class="submit-container">
          <button
            mat-raised-button
            color="primary"
            type="submit"
            class="sButton"
            [disabled]="isSubmitDisabled"
            (click)="onSubmit()"
          >{{isHealthSherpaRegion() ? buttonContentSubmitAsHealthSherpa || "Shop With Health Sherpa" : buttonContentSubmitAsShopX || "Begin Shopping" }}</button>
        </div>
      }
    </div>
  </div>
</div>
